// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"7ccbefa1","543":"731117bf","649":"7012c96d"}[chunkId] + ".css";
};